import styled from "styled-components"

import { color } from "../../../atoms/colors"

export const Section = styled.section`
  width: 100%;
  padding: 40px 0px;
  overflow: hidden;
  @media (min-width: 992px) {
    padding: 56px 0px;
  }
  @media (min-width: 1170px) {
    padding: 96px 0px;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media (min-width: 992px) {
    gap: 48px;
  }
`

export const Header = styled.div`
  width: 100%;
  max-width: 840px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0px auto;
  padding: 0px 35px;
  @media (min-width: 1170px) {
    max-width: 1240px;
  }
  .heading-kicker {
    font-weight: 800;
    font-size: 12px;
    line-height: 18px;
    text-transform: uppercase;
    color: ${color.primary[700]};
    margin: 0px;
    @media (min-width: 577px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
  .heading {
    font-weight: 900;
    font-size: 24px;
    line-height: 32px;
    color: ${color.oxfordBlue[900]};
    margin: 0px;
    @media (min-width: 992px) {
      font-size: 36px;
      line-height: 44px;
    }
    @media (min-width: 1170px) {
      font-size: 48px;
      line-height: 60px;
    }
  }
`

export const Text = styled.div`
  width: 100%;
  max-width: 840px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0px auto;
  padding: 0px 35px;
  @media (min-width: 1170px) {
    max-width: 1240px;
  }
  .subhead,
  .subhead p {
    max-width: 570px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${color.copy[700]};
    margin: 0px;
    @media (min-width: 1170px) {
      max-width: 770px;
      font-size: 18px;
      line-height: 24px;
    }
  }
  .arrow-link {
    width: fit-content;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    @media (min-width: 1170px) {
      font-size: 20px;
      line-height: 30px;
    }
    &:hover {
      text-decoration: none;
    }
  }
`

export const Slider = styled.div`
  position: relative;
  width: 100%;
  max-width: 840px;
  max-height: 314px;
  overflow: visible;
  margin: 0px auto;
  padding-left: 35px;
  @media (min-width: 1170px) {
    max-width: 1240px;
  }
  .swiper {
    height: 100%;
    overflow: visible;
  }
  .swiper-slide {
    width: calc(100% - 35px);
    height: 100%;
    @media (min-width: 576px) {
      width: 470px;
    }
  }
`

export const Slide = styled.div`
  width: 100%;
  height: 100%;
  .gatsby-image-wrapper,
  img {
    width: 100%;
  }
`
